import { useLang } from '@/i18n';
import styles from './index.module.scss';
import EfSection from '@elem/ui/ef-section';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar } from 'swiper';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';

export default function TheComp() {
    const { t } = useLang('theProduct.C_PH');

    const list = [
        {
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
        {
            title: t('item3_title'),
            desc: t('item3_desc'),
        },
        {
            title: t('item4_title'),
            desc: t('item4_desc'),
        },
    ];

    const { isPad, isH5 } = useDeviceDetect();
    return (
        <div className={styles.TheComp}>
            <EfSection hasAnimation={false} label={t('label')} title={t('title')} desc={t('desc')} />
            <Swiper
                className="cards"
                modules={[Scrollbar, Navigation, Pagination]}
                loop={isPad || isH5}
                spaceBetween={20}
                navigation={true}
                slidesPerView={'auto'}
                initialSlide={0}
                pagination={isPad || isH5 ? { clickable: true } : false}
                scrollbar={
                    isPad || isH5
                        ? false
                        : {
                              hide: true,
                              draggable: true,
                              dragSize: 90,
                              snapOnRelease: false,
                          }
                }
                centeredSlides={isPad || isH5}
            >
                {list.map((card: any, k: number) => (
                    <SwiperSlide className={`card item-${k + 1}`} key={k}>
                        <div className="card-content">
                            <p className="card-desc">
                                <span className="comma left-comma">“</span>
                                {card.desc}
                                <span className="comma right-comma">”</span>
                            </p>
                        </div>
                        <p className="card-title">{card?.title}</p>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
